var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"ma-0",attrs:{"height":"3","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }